<template>
  <a-dropdown
    style="display: inline-block; height: 100%; vertical-align: initial"
    v-if="currUser"
  >
    <span style="cursor: pointer">
      <a-avatar v-if="showDefaultAvatarImage" class="avatar" size="small" icon="user"/>
      <a-avatar
        v-else
        class="avatar"
        size="small"
        shape="circle"
        :src="currUser.portraitUrl"
        :loadError="loadAvatarImageError"
      />
      <span>{{ currUser.name }}</span>
    </span>
    <a-menu style="width: 150px" slot="overlay">
      <!--
      <a-menu-item @click="$router.push('/profile')">
        <a-icon type="user" />
        <span>个人中心</span>
      </a-menu-item>
      -->
      <!--
      <a-menu-item @click="$router.push('/setting')">
        <a-icon type="setting" />
        <span>个人设置</span>
      </a-menu-item>
      -->
      <!--<a-menu-divider />-->
      <a-menu-item @click="handleLogout">
        <a-icon type="poweroff" />
        <span>退出登录</span>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
  import Auth from '../router/auth';
export default {
  name: 'HeaderAvatar',
  computed: {
    currUser() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      // 为龙泉演示默认显示user头像 todo
      showDefaultAvatarImage: true
    }
  },
  methods: {
    loadAvatarImageError() {
      console.log("-> loadAvatarImageError");
      this.showDefaultAvatarImage = true;
      //   return "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg";
      return false;
    },
    handleLogout() {
      Auth.logout();
      // this.$store.commit('setResources', []);
      // this.$store.commit('setResourcesInMap', new Map());
      // this.$router.push('/login?auto_logout=1');
    }
  }
};
</script>

<style lang="stylus" scoped>
.avatar
  margin 20px 4px 20px 0
  color #1890ff
  background hsla(0, 0%, 100%, 0.85)
  vertical-align middle
</style>
